import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import Breadcrumbs from 'commons/Breadcrumbs';
import Routes from 'utils/Route';

import BoxInfo from '../BoxInfo';
import useStyles from './styles';

const GalleryInfo = ({ userProfile }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { id } = useParams();

  const breadCrumbs = [
    {
      to: Routes.Home,
      text: t('home'),
    },
    {
      to: Routes.GalleryDetail(id),
      text: t('text_user_name_page', { name: userProfile?.name }),
      active: true,
    },
  ];

  return (
    <>
      <Breadcrumbs
        items={breadCrumbs}
        breadcrumbsStyle={classes.breadcrumbs}
      />

      <Box className={classes.wrapper}>
        <BoxInfo userProfile={userProfile} />
        {/* <BoxStatement
          statement={statement}
          defaultStatement={defaultStatement}
          isOwner={isOwner}
          setStatement={setStatement}
          setDefaultStatement={setDefaultStatement}
        /> */}
      </Box>
    </>
  );
};

export default GalleryInfo;
